/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAffiliateDto
 */
export interface UpdateAffiliateDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAffiliateDto
     */
    code: string;
}

export function UpdateAffiliateDtoFromJSON(json: any): UpdateAffiliateDto {
    return UpdateAffiliateDtoFromJSONTyped(json, false);
}

export function UpdateAffiliateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAffiliateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function UpdateAffiliateDtoToJSON(value?: UpdateAffiliateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

